import React from "react"
import { cn } from "../utils"

// =============================================================================
// Props
// =============================================================================

export type StepperListProps = {
  /** One or more Stepper.Item elements */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const listStyles = [
  "list-[''] [counter-reset:stepper-item]",
  "flex flex-col",
  "p-0"
]

// =============================================================================
// Component
// =============================================================================

/**
 * The ordered list of steps inside a Stepper.
 *
 * Must be a descendant of `Stepper`.
 */
export function StepperList({ children }: StepperListProps) {
  return (
    <ol data-slot="stepper-list" className={cn(listStyles)}>
      {children}
    </ol>
  )
}

StepperList.displayName = "Stepper.List"
